import { useQuery } from "@tanstack/react-query";
import { api } from "../../api/client.ts";
import { keys } from "../../api/queryKeys.ts";

/** A signal's research (runs, briefs, lists, steps), pushed live as its runs go. */
export function useSignalResearch(signalId: string | null | undefined, enabled = true) {
  const id = signalId ?? "";
  return useQuery({
    queryKey: keys.signal.research(id),
    queryFn: () => api.getSignalResearch(id),
    enabled: enabled && !!signalId,
    meta: { live: true },
  });
}
